export { default as inspector } from './inspector.js';
